module.exports = "<source src=\"<%=src%>\" type=\"<%=type%>\">\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/playbacks/html5_video/public/index.html
 ** module id = 141
 ** module chunks = 0
 **/